<template>
  <div>
    <h1>Verifizerung</h1>
    <div>Es wurde eine Verifizierungmail versendet.</div>
    <ion-button @click="sendEmailVerification">
      Mail erneuet senden
    </ion-button>
    <ion-button @click="logout">
      Ausloggen
    </ion-button>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export default {
  name: 'FirebaseLogin',
  methods: {
    presentAlert() {
      this.$ionic.alertController
        .create({
          header: 'Info',
          message: 'Verifizierungsmail erneut gesendet',
          buttons: ['OK'],
        })
        .then((a) => a.present());
    },
    sendEmailVerification() {
      firebase.auth().currentUser.sendEmailVerification();
      this.presentAlert();
    },
    ...mapActions('auth', ['logout']),
  },
};
</script>

<style scoped>

</style>
